<div class="login-container">
  <div class="row g-0">

    <div class="col-md-6 left-side">
      <!-- Left Side -->
      <app-login-image></app-login-image>
    </div>

    <div class="col-md-6 right-side text-center">
      <!-- Right Side - Login Form -->
      <div class="login-form">
        <h1 class="text-center">404</h1>
        <h2>Oops! Page Not Found</h2>
        <p>The page you're looking for doesn't exist or has been moved.</p>
        <div class="action-buttons">
          <a (click)="goToHome()" class="btn-home">Go to Home Page</a>
          <a (click)="goBack()" class="btn-back">Go Back</a>
        </div>
      </div>
    </div>
  </div>
</div>